/**
 * Shopify's cookie banner (Settings → Customer privacy) is injected into <body> at
 * runtime with "Manage preferences" grouped next to Accept / Decline. The T13 layout
 * wants it on one line with the Privacy Policy link, under the copy — those live in
 * different containers, so the button is moved into the copy. Shopify's click handler
 * is bound to the button element itself, so moving it keeps it working. Re-applied
 * whenever Shopify re-renders the banner (region/consent changes).
 * Class/id names are Shopify's and not a public API — if they change, the banner
 * simply keeps its default grouping.
 */
const BANNER_ID = 'shopify-pc__banner'
const MANAGE_ID = 'shopify-pc__banner__btn-manage-prefs'
const LINKS_CLASS = 't13-banner-links'
const PREFS_DIALOG = '#shopify-pc__prefs .shopify-pc__prefs__dialog'
const PREFS_ACTIONS = '.shopify-pc__prefs__header-actions'

function arrange(banner: HTMLElement) {
  const manage = banner.querySelector<HTMLElement>(`#${MANAGE_ID}`)
  const copy = banner.querySelector<HTMLElement>('.shopify-pc__banner__body p')
  if (!manage || !copy || copy.querySelector(`.${LINKS_CLASS}`)) return

  const links = document.createElement('span')
  links.className = LINKS_CLASS

  const policyLink = copy.querySelector<HTMLAnchorElement>('a')
  if (policyLink) links.appendChild(policyLink)
  links.appendChild(manage)

  copy.appendChild(links)
}

// Preferences modal: Accept all / Decline all / Save sit in the header next to the
// title; T13 reads them at the foot, after the choices they act on.
function arrangePrefs() {
  const dialog = document.querySelector<HTMLElement>(PREFS_DIALOG)
  const actions = dialog?.querySelector<HTMLElement>(PREFS_ACTIONS)
  if (!dialog || !actions || actions.parentElement === dialog) return

  dialog.appendChild(actions)
}

function arrangeAll() {
  const banner = document.getElementById(BANNER_ID)
  if (banner) arrange(banner)
  arrangePrefs()
}

// GDPR: visitors must be able to change their choice later. Any link to
// "#cookie-settings" (e.g. "Cookie settings" in the footer's Legal menu) opens
// Shopify's preferences modal. Capture phase so it wins over Taxi's link handling.
function onDocumentClick(e: MouseEvent) {
  const link = (e.target as HTMLElement | null)?.closest('a[href$="#cookie-settings"]')
  if (!link) return

  e.preventDefault()
  e.stopPropagation()
  window.privacyBanner?.showPreferences()
}

export function initPrivacyBanner() {
  arrangeAll()
  new MutationObserver(arrangeAll).observe(document.body, { childList: true })
  document.addEventListener('click', onDocumentClick, true)
}
